import SaveSettings from '../../queries/settings/SaveSettings';

const profileForm = [
  {
    key: 'password',
    label: 'Password',
    value: 'Change Password',
    type: 'Modal',
    form: [
      {
        key: 'old_password',
        label: 'Old Password',
        type: 'input',
        value: ''
      },
      {
        key: 'new_password',
        label: 'New Password',
        type: 'input',
        value: ''
      },
      {
        key: 'confirm_password',
        label: 'Confirm Password',
        type: 'input',
        value: ''
      }
    ]
  }
];

const getData = (settings, searchString, isSetDefaultValue) => {
  const form = [];
  settings.forEach((setting) => {
    let formData = {};
    formData.key = setting.zmPropInfoBase.key;
    formData.label = setting.zmPropInfoBase.label;
    formData.type = setting.zmPropInfoBase.possibleValue
      ? 'dropDown'
      : setting.zmPropInfoBase.type
      ? setting.zmPropInfoBase.type
      : 'input';
    formData.defaultValue = setting.zmPropInfoBase.defaultVal;
    formData.description = setting.zmPropInfoBase.description;
    if ('dropDown' == formData.type) {
      let options = setting.zmPropInfoBase.possibleValue.split(',').map(function(value) {
        return value.trim();
      });
      formData.options = options.map((value, index) => ({
        label: value,
        value: index
      }));
    }
    let value = isSetDefaultValue ? setting.zmPropInfoBase.defaultVal ?? '' : setting.value;
    formData.value = formData.type == 'dropDown' ? formData.options.findIndex((key) => key.label == value) : value;
    formData.global = setting.zmPropInfoBase.global;
    if (searchString != '') {
      if (formData.label.toLowerCase().includes(searchString.toLowerCase())) {
        form.push(formData);
      }
    } else {
      form.push(formData);
    }
  });
  return form;
};

const getSettingFormData = (settingType, searchString = '', isSetDefaultValue = false) => {
  let form;
  switch (settingType) {
    case 'Profile':
      form = profileForm;
      break;
    case 'Application':
      form = getData(SaveSettings.SETTINGS_CACHE, searchString, isSetDefaultValue);
      break;
    case 'Notifications':
      form = getData(SaveSettings.NOTIFICATION_SETTINGS_CACHE, searchString, isSetDefaultValue);
      break;
    default:
      form = [];
      break;
  }
  return [form];
};
export default getSettingFormData;
